// extracted by mini-css-extract-plugin
export default {"footer":"footer__E57gj","withoutDelimiter":"withoutDelimiter__jPZmz","innogamesLogoLink":"innogamesLogoLink__jko0S","innogamesLogo":"innogamesLogo__iD_TP","footerHeading":"footerHeading__EGfrq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"footer\":\"footer__E57gj\",\"withoutDelimiter\":\"withoutDelimiter__jPZmz\",\"innogamesLogoLink\":\"innogamesLogoLink__jko0S\",\"innogamesLogo\":\"innogamesLogo__iD_TP\",\"footerHeading\":\"footerHeading__EGfrq\"}";
        // 1787130557200
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  